import { useAuthentication } from '@givebacks/api';
import { useNavigate } from 'react-router-dom';

export const useLogoutUser = () => {
  const navigate = useNavigate();
  const { logOut } = useAuthentication();
  const userLogout = async ({ callBack }: { callBack?: any }) => {
    await logOut();
    callBack && callBack();
    window.scrollTo(0, 0);
    navigate('/');
  };
  return { userLogout };
};
